import type { useToast } from 'bootstrap-vue-next';

type ToastController = ReturnType<typeof useToast>;

// Vue 3 / bootstrap-vue-next : le toast programmatique passe par le controller (useToast) capturé
// une fois dans main.ts et injecté ici. `show?.()` est un no-op si le plugin/orchestrator est absent
// (ex. specs jest) → jamais de crash. On garde le param `instance` pour la traduction `$t`.
// bootstrap-vue-next 0.45 : le param de `show()` est plat (props BToast au niveau racine) ; `pos`/`value`/`{props}`
// sont dépréciés → on utilise `position` et `modelValue` (délai d'auto-fermeture, ms).
// `noProgress: true` masque la barre de progression du décompte (bleue par défaut, jure avec le toast) — le toast
// se ferme toujours seul après `modelValue` ms, mais sans cette barre.
export default class AlertService {
  constructor(private toast: ToastController) {}

  public showError(instance: any, message: string, params?: any) {
    const alertMessage = instance.$t(message, params);
    this.toast?.show?.({
      body: alertMessage.toString(),
      title: 'Erreur',
      variant: 'danger',
      position: 'top-center',
      modelValue: 5000,
      noProgress: true,
    });
  }

  public showSuccess(instance: any, message: string, params?: any) {
    const alertMessage = instance.$t(message, params);
    this.toast?.show?.({
      body: alertMessage.toString(),
      title: 'Succès',
      variant: 'success',
      position: 'top-center',
      modelValue: 5000,
      noProgress: true,
    });
  }

  public showHttpError(instance: any, httpErrorResponse: any) {
    switch (httpErrorResponse.status) {
      case 0:
        this.showError(instance, 'error.server.not.reachable');
        break;

      case 400: {
        const arr = Object.keys(httpErrorResponse.headers);
        let errorHeader: string | null = null;
        let entityKey: string | null = null;
        for (const entry of arr) {
          if (entry.toLowerCase().endsWith('app-error')) {
            errorHeader = httpErrorResponse.headers[entry];
          } else if (entry.toLowerCase().endsWith('app-params')) {
            entityKey = httpErrorResponse.headers[entry];
          }
        }
        if (errorHeader) {
          const alertData = entityKey ? { entityName: instance.$t(`global.menu.entities.${entityKey}`) } : undefined;
          this.showError(instance, errorHeader, alertData);
        } else if (httpErrorResponse.data !== '' && httpErrorResponse.data.fieldErrors) {
          this.showError(instance, httpErrorResponse.data.message);
        } else {
          this.showError(instance, httpErrorResponse.data.message);
        }
        break;
      }

      case 404:
        this.showError(instance, 'error.http.404');
        break;

      default:
        this.showError(instance, httpErrorResponse.data.message);
    }
  }
}
